import { rgba } from 'polished';
import { ColorScheme } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

export const Link = styled(QueryNavLink)<{
  $active: boolean;
  $isMoving: boolean;
  $isFrozen: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};

  border-radius: ${({ theme }) => theme.spacing(2.5)};
  transition:
    background 200ms,
    color 200ms;

  text-decoration: none;
  color: ${({ theme }) =>
    rgba(
      theme.palette.text.primary,
      theme.colorScheme === ColorScheme.Dark ? 0.6 : 0.8,
    )};

  ${({ $active }) =>
    $active
      ? css`
          ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
          background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
          color: ${({ theme }) => theme.palette.text.primary};

          &:focus {
            background: ${({ theme }) =>
              rgba(theme.palette.text.primary, 0.06)};
            color: ${({ theme }) => theme.palette.text.primary};
          }
        `
      : css`
          &:hover {
            background: ${({ theme }) =>
              rgba(theme.palette.text.primary, 0.06)};
          }
        `};

  ${({ theme, $isMoving }) =>
    $isMoving &&
    css`
      background: ${theme.palette.background.default};

      &:hover {
        background: ${theme.palette.background.default};
      }
    `};

  ${({ $isFrozen }) =>
    $isFrozen &&
    css`
      opacity: 0.5;
    `};
`;

export const IconContainer = styled.span<{
  $active: boolean;
  $color?: string | null;
}>`
  display: flex;
  align-items: center;
  transition: color 200ms;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme, $active, $color }) =>
    $color ?? ($active ? 'inherit' : rgba(theme.palette.text.primary, 0.7))};
`;

export const Title = styled.span<{ $completed: boolean }>`
  display: block;
  flex: 1;

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $completed }) =>
    $completed &&
    css`
      text-decoration: line-through;
    `};
`;

export const TimeLeftContainer = styled.span<{ $active: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme, $active }) =>
    $active ? 'inherit' : theme.palette.text.secondary};
`;

export const IconButtonContainer = styled.div`
  width: 0;
  opacity: 0;
  margin-left: 0;
  overflow: hidden;

  transition:
    width 200ms,
    opacity 200ms,
    margin-left 200ms;

  ${Link}:hover & {
    width: 2.2rem;
    opacity: 1;
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;
